export default "__VITE_ASSET__COQ48YKG__"